import React from 'react';
import {LEFT} from './constants.js';
import './style.scss';

const DoubleArrow = React.memo(({orientation}) => <span className={`double-arrow faa-angle-double-${orientation === LEFT ? 'left' : 'right'}`} />);

export default DoubleArrow;
